// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"997ebc7a","287":"ce315198","301":"7bc8747e","373":"167ff644","420":"63b6d953","762":"066fc5ea","838":"6d44dd8b"}[chunkId] + ".chunk.js";
};